import request from '@/utils/request';

export function queryPreviousLuckyDrawListDXP(gameCode) {
  return request(`/promotion-rest-boot/dxp/game/v1/grand-raffle-game/${gameCode}/history`, {
    method: 'GET',
  });
}

// 领取奖品
export function toReceivePrizesDXP(data) {
  return request('/promotion-rest-boot/dxp/game/v1/reward-instance/claim', {
    method: 'POST',
    // data,
    data,
  });
}
